
import {createContext, useState} from 'react'

const Context = createContext()

export const ProductContextProvider = ({children}) => {
 const [allProducts, setAllProducts] = useState([])
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allProducts, setAllProducts, message, setMessage}}>
  {children}
 </Context.Provider>
}
export default Context